import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { addressDrawerApplyButtonStyles } from "@insite/content-library/Widgets/Header/AddressDrawerApplyButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

addressDrawerApplyButtonStyles.gridItem = mergeToNew(addressDrawerApplyButtonStyles.gridItem, {
    css: css`
        justify-content: center;
        padding-bottom: 0px !important;
        margin-top: 30px !important;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 12px !important;
                        padding-bottom: 25px !important;
                    `,
                ],
                "max",
            )}
    `,
});
